export const USERS_INPUT = 'USERS_INPUT' as const;
export const USERS_OUTPUT = 'USERS_OUTPUT' as const;
